import { callAuthorizedGraphQLEndpoint } from '../../../../../Module/graphQL'

const getRejectedCampaign = ({ campaignId, clientId }) => {
  const query = `query ($clientId: ID, $campaignId: ID) {
    campaignsBuilderData(input: { clientId: $clientId, campaignId: $campaignId }){
      nodes {
        campaignId
        startDate
        internalStatus
        campaignName
        createdAt
        paymentStatus
        lastActiveStep
        declineCampaignEmail
        type
        subtype
      }
    }
  }`

  return callAuthorizedGraphQLEndpoint(query, {
    campaignId,
    clientId,
  })
}

export { getRejectedCampaign }
